import React from "react";
import "./CertificationSection.css";

const certifications = [
  {
    name: "Gemological Institute of America",
    description:
      "The Gemological Institute of America (GIA) is recognized worldwide as the foremost authority in gemology. Their diamond grading reports are the industry standard for diamond quality assurance and authenticity.",
    logo: "https://www.gia.edu/assets/img/global-header/desktop/gia-logo.svg",
    link: "https://www.gia.edu/",
  },
  {
    name: "International Gemological Institute",
    description:
      "The International Gemological Institute (IGI) is a global leader in diamond certification and jewelry appraisal. Their comprehensive evaluations provide detailed assessments of a diamond's quality and characteristics.",
    logo: "https://www.igi.org/wp-content/uploads/cropped-logo_IGI-1.png",
    link: "https://www.igi.org/",
  },
];

export default function CertificationSection() {
  return (
    <section id="certification" className="certification1-section">
      <div className="container4">
        <h2 className="section-title2">Our Certifications</h2>
        <div className="certification1-grid">
          {certifications.map((cert, index) => (
            <div
              key={index}
              className="certification1-card"
              onClick={() => window.open(cert.link, "_blank")}
            >
              <div className="certification1-content">
                <div className="certification1-logo">
                  <img src={cert.logo} alt={cert.name} className="logo-image1" />
                </div>
                <div className="certification1-details">
                  <h3 className="certification1-title">{cert.name}</h3>
                  <p className="certification1-description">
                    {cert.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
